import {BookingProcessSuccessEnum} from 'main/analytics/gaTagsEnum';
import React from 'react';
import {StyledList} from './styles';
import {ProfessionalDateListProps} from './types';

export function ProfessionalDateList({children}: ProfessionalDateListProps) {
	return (
		<StyledList
			data-tag-id={BookingProcessSuccessEnum.ENCONTROU_HORARIOS_DISPONIVEIS}
			subheader={<li />}>
			{children}
		</StyledList>
	);
}
